import { Fetch, schemas } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';

export function logout(fetch: Fetch) {
    return fetch(
        '/auth/logout',
        {
            method: 'POST'
        },
        schemas.SuccessDto
    );
}

export function useLogoutMutation(fetch: Fetch) {
    return useMutation({
        mutationFn: () => logout(fetch),
        mutationKey: ['logout']
    });
}
